import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { Environment } from '../../types/environment';
import { OAuthConfig } from '../../oauth.config';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  constructor(@Inject(APP_ENVIRONMENT) private readonly env: Environment) {}

  getGoogleOAuthConfig(): Omit<OAuthConfig, 'redirectUri'> {
    return {
      clientId: this.env.googleOAuthClientId,
      issuer: this.env.googleOAuthIssuer,
      jwksUrl: this.env.googleOAuthJwksUrl,
      loginUrl: this.env.googleOAuthLoginUrl,
      tokenEndpoint: this.env.googleOAuthTokenEndpoint,
      userinfoEndpoint: this.env.googleOAuthUserinfoEndpoint,
    };
  }

  getApiUrl() {
    return this.env.apiUrl;
  }
}
